import TRANSACTION_STATSUS from "./custom/transactionStatus";
import ENV from "./custom/env";
import SITE_MAP from "./custom/sitemap";
import POINT_NAME from "./custom/pointName";
import LIMITS from "./custom/limits";
import TOOLTIP_TEXT from "./custom/tooltipText";

export default {
  TRANSACTION_STATSUS, //ポイントトランザクション状況
  SITE_MAP, //新新IC_SiteMap_一般
  ENV, // 環境
  POINT_NAME, // ポイント名称
  LIMITS, // 上限値・下限値
  TOOLTIP_TEXT // ツールチップ表示文言
};
